import resume from '../assets/pdf/resume.pdf'

export const headerData = {
    name: 'Ayush Agrawal',
    title: "Hello! I'am",
    desciption:"There wasn't a bird in the sky, but that was not what caught her attention. It was the clouds. The deep green that isn't the color of clouds, but came with these. She knew what was coming and she hoped she was prepared. ",
    image: 'https://i.imgur.com/4YMfAol.jpg',
    resumePdf: resume
}
